import { render, staticRenderFns } from "./Overlays_Pointer.vue?vue&type=template&id=2b7cf05d&"
import script from "./Overlays_Pointer.vue?vue&type=script&lang=js&"
export * from "./Overlays_Pointer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports